import { useEffect, useState } from "react";
import { AlertCircle } from "lucide-react";

// Focus view for a single MediaAsset, rendered inside the shared
// ModalManager stack (backdrop/close/Escape/scroll-lock/click-outside are
// all handled by ModalBackdrop — this component only owns the media itself).
export default function MediaFocusModal({ media }) {
  const [failed, setFailed] = useState(false);

  // A new asset may be focused without the modal fully closing/reopening
  // (not currently possible in V1, but cheap to guard against).
  useEffect(() => {
    setFailed(false);
  }, [media?.id]);

  if (!media) return null;

  const isVideo = media.media_type === "video";
  const label = media.original_filename || (isVideo ? "Video" : "Image");

  return (
    <div
      className="relative flex items-center justify-center max-w-full max-h-[90vh]"
      onClick={(e) => e.stopPropagation()}
    >
      {failed ? (
        <div className="flex flex-col items-center gap-2 p-10 text-white">
          <AlertCircle size={28} />
          <p className="text-sm">{isVideo ? "Unable to load video." : "Unable to load image."}</p>
        </div>
      ) : isVideo ? (
        <video
          key={media.id}
          src={media.url}
          poster={media.thumbnail_url || undefined}
          controls
          playsInline
          preload="metadata"
          aria-label={label}
          className="max-w-full max-h-[90vh] object-contain"
          onError={() => setFailed(true)}
        />
      ) : (
        <img
          src={media.url}
          alt={label}
          className="max-w-full max-h-[90vh] object-contain"
          onError={() => setFailed(true)}
        />
      )}
    </div>
  );
}
